import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PLAN_TYPES, SUBSCRIPTION_STATUS, USER_TYPE } from '@teem/constants/subscription';
import { SharedDataService } from '@teem/services/shared-data.service';
import { TeemappService } from '@teem/services/teemapp.service';
import { LoaderService } from '@teem/services/loader.service';
import { UserService } from '@teem/services/user.service';
import * as COUNTRIES from '@teem/constants/country';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { MixpanelService } from '@teem/services/mixpanel.service';
import { environment } from '@teem/environments/environment';



@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {
  userInfo: any = {};
  basicInfo: any = {};
  subscription: any;
  plans: any;
  COUNTRIES: any = COUNTRIES;
  tapCountries: any = COUNTRIES.TAP_ACTIVE_COUNTRY;
  experimentInfo: any;
  userProperties: any;
  referenceDate: Date = new Date(environment.newFreeTrailStartDate);

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private route: ActivatedRoute,
    private teemappService: TeemappService,
    private sharedDataService: SharedDataService,
    private mixpanelService: MixpanelService,
  ) { }

  ngOnInit(): void {

    this.fetchUserInfo();
    this.fetchPlans();

    this.sharedDataService.asObservable().subscribe((data) => {
      if (data) {
        if (data.userInfo) {
          this.basicInfo = data.userInfo;
          this.subscription = data.userInfo.subscription;

          if (this.basicInfo && this.basicInfo.subscription_status == SUBSCRIPTION_STATUS.free)
            this.scrollToPlanTab();
        }
      }
    })

    this.route.queryParams.subscribe(params => {
      if (params && params['tab'] && params['tab'] == 'plans') {
        this.scrollToPlanTab();
        this.userService.getUser().subscribe(data => {
          this.userInfo = data;
          // Mixpanel event settings_plans_view
          this.userProperties = this.mixpanelService.getUserProperties(this.userInfo);
          let trackProperties = this.mixpanelService.getTrackProperties(this.userInfo);

          let combinedProperties = {
            ...this.userProperties,
            ...trackProperties
          };
          // this.mixpanelService.setUserProperties(this.userProperties);
          this.mixpanelService.track('settings_plans_view', combinedProperties);
          // console.log(this.userInfo)
          if (this.userInfo?.billing_experimente_data?.name) {
            this.mixpanelService.unionUserProperties({ 'experiments': this.userInfo.billing_experimente_data.name })
          }
        });
      }
    });
  }

  isUser() {
    if (this.userInfo && this.userInfo?.user_type)
      return this.userInfo?.user_type == USER_TYPE.user;
    else
      false;
  }

  isAdmin() {
    if (this.userInfo && this.userInfo?.user_type)
      return (this.userInfo?.user_type == USER_TYPE.admin || this.userInfo?.user_type == USER_TYPE.super_admin);
    else
      false;
  }

  isSuperAdmin() {
    if (this.userInfo && this.userInfo?.user_type)
      return this.userInfo?.user_type == USER_TYPE.super_admin;
    else
      false;
  }

  fetchUserInfo() {
    // alert()
    this.loaderService.startLoading();
    this.userService.getUser().subscribe(data => {
      this.userInfo = data;
      this.subscription = this.userInfo ? this.userInfo.subscription : null;
      this.experimentInfo = this.userInfo?.billing_experimente_data?.is_experiment == 1 ? true : false;

      // Mixpanel event settings_view
      this.userProperties = this.mixpanelService.getUserProperties(this.userInfo);
      let trackProperties = this.mixpanelService.getTrackProperties(this.userInfo);

          let combinedProperties = {
            ...this.userProperties,
            ...trackProperties
          };
      this.mixpanelService.setUserProperties(this.userProperties);
      this.mixpanelService.track('settings_view', combinedProperties);
      if (this.userInfo?.billing_experimente_data?.name) {
        this.mixpanelService.unionUserProperties({ 'experiments': this.userInfo.billing_experimente_data.name })
      }
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    });
  }

  terminateAccount() {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.setting.terminate_your_account,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    }).then((result: any) => {
      if (result.value) {
        this.loaderService.startLoading();
        this.userService.terminateUser().subscribe(() => {
          this.loaderService.stopLoading();
          setTimeout(function () {
            Swal.fire(i18n.done, '', 'success').then(() => {
              window.location.reload();
            });
          }, 0);
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      } else {
        return false;
      }
    });
  }

  getTap() {
    return this.tapCountries.some(x => x == this.userInfo?.country_id)
  }

  fetchPlans() {
    this.teemappService.getPlans().subscribe((data: any) => {
      this.plans = data;
    });
  }

  onPlanChange() {
    window.location.reload()
  }

  scrollToPlanTab() {
    let element = document.getElementById("targetScroll");
    if (element) {
      console.log('IN')
      setTimeout(function () {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }, 700);
    } else {
      console.log('OUT')
    }
  }

  isEmpty(obj: any): boolean {
    return obj == null || Object.keys(obj).length === 0;
  }

  isVerifyAtGreater(): boolean {
    const verifiedDate = new Date(this.basicInfo.verified_at);    
    return (verifiedDate > this.referenceDate);
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      // Mixpanel event settings_plans_view
      this.userProperties = this.mixpanelService.getUserProperties(this.userInfo);
      let trackProperties = this.mixpanelService.getTrackProperties(this.userInfo);

          let combinedProperties = {
            ...this.userProperties,
            ...trackProperties
          };
      // this.mixpanelService.setUserProperties(this.userProperties);
      this.mixpanelService.track('settings_plans_view', combinedProperties);
      if (this.userInfo?.billing_experimente_data?.name) {
        this.mixpanelService.unionUserProperties({ 'experiments': this.userInfo.billing_experimente_data.name })
      }
    }
  }
}
